<mat-card class="superadmin-registration">
  <mat-card-header>
    <div class="g-just-flex flex-between w-100">
      <div class="left">
        <mat-card-title>Create SuperAdmin User</mat-card-title>
        <mat-card-subtitle>Add a new system super administrator</mat-card-subtitle>
      </div>
      <div class="right">
        <button mat-icon-button (click)="cancel()" matTooltip="Cancel">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content class="my-12">
    <div class="info-box">
      <mat-icon>info</mat-icon>
      <div class="info-content">
        <strong>Important:</strong> SuperAdmin users have full system access and are not associated with any organization. 
        A temporary password will be automatically generated and sent to the email address provided.
      </div>
    </div>

    <div class="form-container">
      @if(formMeta && formFields) {
      <app-dynamic-forms-v2 
        [formMetaData]="formMeta" 
        [formFields]="formFields"
        [resetOnSubmit]="false" 
        (formSubmitted)="onSubmit($event)">
      </app-dynamic-forms-v2>
      }
    </div>

    <div class="action-buttons">
      <button mat-stroked-button (click)="cancel()">
        Cancel
      </button>
    </div>
  </mat-card-content>
</mat-card>